import clsx from 'clsx';
import { FC } from 'react';
import { IField } from '../../../types';
import Label from '../label';
import styles from './styles.module.css';

const Field: FC<IField> = props => {
  const {
    label,
    labelProps = {},
    className = '',
    fullwidth = false,
    required = false,
    errorMessage,
    children,
    ...rest
  } = props;

  const fullwidthClass = fullwidth ? 'is-fullwidth' : '';

  return (
    <div className={clsx('field', styles.field, fullwidthClass, className)} {...rest}>
      {Boolean(label) && (
        <Label required={required} {...labelProps}>
          {label}
        </Label>
      )}

      {children}

      {Boolean(errorMessage) && <p className={clsx('help', 'is-danger')}>{errorMessage}</p>}
    </div>
  );
};

export default Field;
